'use client';
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useT } from "../../i18n";
import { SectionKicker } from "./shared";

export function ActThree({ onComplete }: { onComplete: () => void }) {
  const t = useT();

  const layerCards = [
    { tag: "MANAGEMENT LAYER", title: t('landlink.three.card1.title'), copy: t('landlink.three.card1.copy') },
    { tag: "FRONTLINE LAYER", title: t('landlink.three.card2.title'), copy: t('landlink.three.card2.copy') },
  ];

  return (
    <motion.section
      className="act act-three"
      initial={{ opacity: 0, x: "12%" }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: "-10%", filter: "blur(8px)" }}
      transition={{ duration: 0.6 }}
    >
      <div className="act-bg" />
      <div className="shade" />
      <div className="grain" />

      <div className="act-content">
        <div className="solution-copy">
          <SectionKicker>LANDLINK BEHAVIOUR ENGINE</SectionKicker>
          <h2>
            {t('landlink.three.titlePre')}
            <br />
            {t('landlink.three.titleMid')}<span>{t('landlink.three.titleHighlight')}</span>{t('landlink.three.titlePost')}
          </h2>
          <p className="body-text">
            {t('landlink.three.body')}
          </p>
          <button className="solution-cta" onClick={onComplete}>
            {t('landlink.three.cta')} <ArrowRight size={20} />
          </button>
        </div>

        <div className="solution-cards">
          {layerCards.map((card, index) => (
            <motion.article
              key={card.tag}
              className="solution-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.25 + index * 0.15 }}
              whileHover={{ y: -4 }}
            >
              <small>0{index + 1}</small>
              <h3>{card.title}</h3>
              <p>{card.copy}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
